import AbstractConfig from "./AbstractConfig";

export default class Config extends AbstractConfig {
    constructor() {
        super();
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);
        this.setValue(Config.APPID, obj.general.appID);
        this.setValue(Config.BUILDID, obj.general.build);
        this.setValue(Config.ANALYTICS_VERSION, obj.googleanalytics.analyticsVersion);
        this.setValue(Config.CONTENT_VERSION, obj.general.contentVersion);
        this.setValue(Config.COMMIT_HASH, obj.general.commitHash);
        this.setValue(Config.ENVIRONMENT, obj.general.environment);
    }
}

Config.APPID = "APP_ID";
Config.BUILDID = "BUILD_ID";
Config.ANALYTICS_VERSION = "ANALYTICS_VERSION";
Config.CONTENT_VERSION = "CONTENT_VERSION";
Config.COMMIT_HASH = "COMMIT_HASH";
Config.ENVIRONMENT = "CFG_ENVIRONMENT";